import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

/**
 * Vuetify make use of a theme 'light' and 'dark'
 * but our palette only use 'brand' and 'neutral' colors
 *
 * to say: our palette do not have a 'light' and 'dark' theme
 *
 * because of that, to use a 'dark theme'
 * it's necessary to manually set it in the component
 */

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // DO NOT CHANGE 'brand' or 'neutral'
        // for color reference, go to '@/assets/scss/src/_variables.scss'
        brand: {
          base: '#3f55ee',
          lighten1: '#a0acff',
          lighten2: '#ebedff',
          lighten3: '#f8f8ff',
          darken1: '#0f21a1',
          darken2: '#1e2977',
          darken3: '#0B134A',
          background: '#f8f8ff',
        },
        neutral: {
          base: '#373B54',
          lighten1: '#585D83',
          lighten2: '#C2C6E7',
          lighten3: '#E6E8F8',
          lighten4: '#FFFFFF',
          darken1: '#232536',
          darken2: '#171924',
          darken3: '#0F1118',
        },
        // DO NOT CHANGE 'brand' or 'neutral'

        primary: '#3F55EE',
        blueMarine: {
          base: '#585D83',
          darken1: '#1E2977',
          darken2: '#373B54',
          lighten1: '#C2C6E7',
        },
        progressBar: {
          base: '#c5cbfd',
          lighten1: '#eeeeee',
          darken1: '#A7B2FF',
        },
        light: '#5b9bf3',
        secondary: '#F9F9F9',
        turquisePanda: '#3e50f7',
        background: '#FFFFFF',
        backgroundAlert: '#f1f3f4',
        lighter: '#e7e9fa',
        darker: '#131e3f',
        icon: '#C1CBE6',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        text: '#FFFFFF',
        secondaryText: '#6F6F6F',
        black: '#000000',
        issue: '#FDEDF5',
        notSelectedOption: '#3F55EE',
        selectedOption: '#2B3BAB',
        newTitle: '#1E2977',
        newBackground: '#f8f8ff',
        lightenText: '#A0ACFF',
        backgroundLighten: '#ffffff',
        menuText: '#3F55EE',
        contrast: '#E6E8F8',
        tabsSelected: '#0F21A1',
        tabsUnselected: '#585D83',
        feedback: '#FFECB3',
        button: '#3F55EE',
        danger: {
          base: '#FFCDD2',
          darken1: '#B71C1C',
        },
        textType: '#585D83',
        textType2: '#373B54',
      },
      dark: {
        // DO NOT CHANGE 'brand' or 'neutral'
        // for color reference, go to '@/assets/scss/src/_variables.scss'
        brand: {
          base: '#3f55ee',
          lighten1: '#a0acff',
          lighten2: '#ebedff',
          lighten3: '#f8f8ff',
          darken1: '#0f21a1',
          darken2: '#1e2977',
          darken3: '#0B134A',
          background: '#0F1118',
        },
        neutral: {
          base: '#373B54',
          lighten1: '#585D83',
          lighten2: '#C2C6E7',
          lighten3: '#E6E8F8',
          lighten4: '#FFFFFF',
          darken1: '#232536',
          darken2: '#171924',
          darken3: '#0F1118',
        },
        // DO NOT CHANGE 'brand' or 'neutral'

        primary: '#A0ACFF',
        blueMarine: {
          base: '#C2C6E7',
          darken1: '#8fb1e3',
          darken2: '#E6E8F8',
          lighten1: '#C2C6E7',
        },
        progressBar: {
          base: '#373B54',
          lighten1: '#eeeeee',
          darken1: '#ebedff',
        },
        main: '#121212',
        background: '#171924',
        backgroundAlert: '#272b2c',
        text: '#cdcbc9',
        turquisePanda: '#478ef7',
        issue: '#39061f',
        notSelectedOption: '#3F55EE',
        newTitle: '#EBEDFF',
        newBackground: '#0F1118',
        backgroundLighten: '#373b54',
        menuText: '#A0ACFF',
        contrast: '#373B54',
        tabsSelected: '#EBEDFF',
        tabsUnselected: '#A0ACFF',
        feedback: '#7d5e00',
        button: '#3F55EE',
        danger: {
          base: '#FFCDD2',
          darken1: '#B71C1C',
        },
        textType: '#FFFFFF',
        textType2: '#FFFFFF',
      },
    },
  },
})
